import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4af39e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-section ncgr-section--grouped-background ncgr-section--short ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_2 = { class: "ncgr-container -size-l -is-gapless" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "product-image" }
const _hoisted_6 = {
  key: 0,
  class: "ncgr-card"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "description" }
const _hoisted_9 = {
  key: 0,
  class: "achievement"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "thumbs-container" }
const _hoisted_13 = {
  key: 0,
  class: "thumbs"
}
const _hoisted_14 = ["src", "alt", "onClick"]
const _hoisted_15 = { class: "right" }
const _hoisted_16 = {
  key: 0,
  class: "ncgr-card ncgr-pad-16"
}
const _hoisted_17 = {
  key: 0,
  class: "ncgr-alert -color-primary -appearance-flat ncgr-mar-b-16"
}
const _hoisted_18 = { class: "alert-content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ncgr-typography-bold" }, " このアイテムは予約販売です。 ", -1))
const _hoisted_20 = { class: "ncgr-typography-normal" }
const _hoisted_21 = { class: "ncgr-pad-t-8" }
const _hoisted_22 = { class: "ncgr-typography-normal" }
const _hoisted_23 = { class: "ncgr-typography-normal" }
const _hoisted_24 = {
  key: 1,
  class: "ncgr-alert -color-warning -appearance-flat ncgr-mar-b-16"
}
const _hoisted_25 = { class: "alert-content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ncgr-typography-bold" }, " このアイテムはサンプル発注用です。 ", -1))
const _hoisted_27 = { class: "ncgr-typography-normal" }
const _hoisted_28 = { class: "ncgr-pad-t-8" }
const _hoisted_29 = { class: "ncgr-typography-normal" }
const _hoisted_30 = { class: "ncgr-typography-normal" }
const _hoisted_31 = { class: "ncgr-heading -size-m" }
const _hoisted_32 = { class: "ncgr-typography-small ncgr-typography-secondary-label ncgr-typography-bold" }
const _hoisted_33 = {
  key: 2,
  class: "ncgr-mar-b-16"
}
const _hoisted_34 = { class: "ncgr-mar-b-16" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "color"
}, "カラーを選択", -1))
const _hoisted_36 = { class: "_control" }
const _hoisted_37 = { class: "_input color-select" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_trailing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "arrow_drop_down"
    })
  ])
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "size"
}, "サイズを選択", -1))
const _hoisted_40 = { class: "_control" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "未選択", -1))
const _hoisted_42 = ["value"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_trailing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "arrow_drop_down"
    })
  ])
], -1))
const _hoisted_44 = {
  key: 3,
  class: "ncgr-typography-bold ncgr-mar-t-16"
}
const _hoisted_45 = { class: "ncgr-typography-success" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "tenso",
  href: "https://www.tenso.com/en/guide/shop/shop.html?bn_code=BN-20141029154637",
  target: "_blank",
  rel: "noopener"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www2.tenso.com/ext/banner.php?f=gmo_pepabo_1280x300_en.jpg",
    alt: "海外発送/国際配送サービスの転送コム",
    class: "ncgr-is-visible"
  })
], -1))
const _hoisted_47 = { class: "ncgr-mar-t-16 if-tablet-hide" }
const _hoisted_48 = {
  key: 0,
  class: "countdown-pc-area"
}
const _hoisted_49 = ["disabled", "onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "cart"
  })
], -1))
const _hoisted_51 = { class: "_body" }
const _hoisted_52 = { class: "countdown-pc" }
const _hoisted_53 = { class: "ncgr-typography-bold" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "cart"
  })
], -1))
const _hoisted_57 = { class: "_body" }
const _hoisted_58 = { class: "ncgr-card ncgr-pad-16 ncgr-border-t" }
const _hoisted_59 = { class: "ncgr-mar-b-24" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s ncgr-mar-b-8" }, " つくった人 ", -1))
const _hoisted_61 = ["href"]
const _hoisted_62 = { class: "ncgr-avatar -size-m" }
const _hoisted_63 = ["src"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["href"]
const _hoisted_66 = {
  key: 0,
  class: "ncgr-mar-b-16"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s" }, " このアイテムについて ", -1))
const _hoisted_68 = {
  key: 1,
  class: "ncgr-mar-b-24"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s ncgr-mar-b-8" }, " 印刷方法 ", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " シルクスクリーン印刷 ", -1))
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = { class: "ncgr-mar-b-16" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s" }, " 送料(税込) ", -1))
const _hoisted_74 = {
  key: 0,
  class: "ncgr-ul -density-dense"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " 宅急便 / ゆうパック 770円 ", -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "ncgr-ul -density-dense" }, [
  /*#__PURE__*/_createElementVNode("li", null, " ネコポス便 / ゆうパケット 385円 "),
  /*#__PURE__*/_createElementVNode("li", null, " 宅急便 / ゆうパック 770円 ")
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "※ 2枚以上購入される場合は、宅急便、もしくはゆうパックでの配送になります。", -1))
const _hoisted_79 = { class: "ncgr-mar-b-16" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s" }, " 印刷上の注意 ", -1))
const _hoisted_81 = { class: "ncgr-ul -density-dense" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " 画像は合成イメージです。実際のアイテムとは異なる場合があります。 ", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " ご使用のモニターの設定により、実際の色味と異なる場合があります。 ", -1))
const _hoisted_85 = { key: 1 }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ncgr-mar-b-16" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s" }, " 配送上の注意 "),
  /*#__PURE__*/_createElementVNode("ul", { class: "ncgr-ul -density-dense" }, [
    /*#__PURE__*/_createElementVNode("li", null, " このアイテムは受注製作となるため、ご注文から発送までにお時間がかかります。 "),
    /*#__PURE__*/_createElementVNode("li", null, " 販売期間の終了後に、製作を開始します。 ")
  ])
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s" }, " サイズ ", -1))
const _hoisted_88 = {
  key: 1,
  class: "ncgr-card ncgr-pad-16"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ncgr-button -appearance-outlined" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "exclamation_on_triangle"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "_body" }, " 通報する ")
], -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = {
  key: 2,
  class: "ncgr-card ncgr-pad-16 ncgr-border-t"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "node"
  })
], -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, " シェア ", -1))
const _hoisted_94 = [
  _hoisted_92,
  _hoisted_93
]
const _hoisted_95 = { class: "bottom-action-area if-tablet-show" }
const _hoisted_96 = {
  key: 0,
  class: "countdown-tablet"
}
const _hoisted_97 = { class: "ncgr-typography-bold" }
const _hoisted_98 = { class: "bottom-action-bar" }
const _hoisted_99 = ["disabled", "onClick"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "cart"
  })
], -1))
const _hoisted_101 = { class: "_body" }
const _hoisted_102 = { class: "ncgr-app-bar -appearance-transparent -position-relative --activated" }
const _hoisted_103 = { class: "_content" }
const _hoisted_104 = { class: "_leading" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "cross"
  })
], -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_title" }, " カラーを選択 ")
], -1))
const _hoisted_108 = { class: "ncgr-semi-modal__body" }
const _hoisted_109 = { class: "ncgr-semi-modal__contents -active" }
const _hoisted_110 = {
  key: 0,
  class: "ncgr-container ncgr-pad-t-24 ncgr-pad-b-24"
}
const _hoisted_111 = { class: "ncgr-row" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = ["src"]
const _hoisted_114 = { class: "ncgr-mar-t-8" }
const _hoisted_115 = { class: "ncgr-typography-small" }
const _hoisted_116 = { class: "ncgr-app-bar -appearance-transparent -position-relative --activated" }
const _hoisted_117 = { class: "_content" }
const _hoisted_118 = { class: "_leading" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "cross"
  })
], -1))
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_title" }, " シェア ")
], -1))
const _hoisted_122 = { class: "ncgr-semi-modal__body" }
const _hoisted_123 = { class: "ncgr-semi-modal__contents -active" }
const _hoisted_124 = {
  key: 0,
  class: "ncgr-interactive-list"
}
const _hoisted_125 = { class: "_list" }
const _hoisted_126 = { class: "_item" }
const _hoisted_127 = ["href"]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "x"
    })
  ])
], -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_title" }, " ポストする ")
], -1))
const _hoisted_130 = [
  _hoisted_128,
  _hoisted_129
]
const _hoisted_131 = { class: "_item" }
const _hoisted_132 = ["href"]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "line"
    })
  ])
], -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_title" }, " LINEで送る ")
], -1))
const _hoisted_135 = [
  _hoisted_133,
  _hoisted_134
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuzuriHeader = _resolveComponent("SuzuriHeader")!
  const _component_ThumbnailCaption = _resolveComponent("ThumbnailCaption")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ItemSpec = _resolveComponent("ItemSpec")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_track = _resolveDirective("track")!

  return (_openBlock(), _createBlock(_component_Form, { as: "" }, {
    default: _withCtx(({ validate }) => [
      _createVNode(_component_SuzuriHeader),
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.selectedVariant)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          src: _ctx.thumbnailUrl(_ctx.selectedScene, _ctx.mainThumbnailSize),
                          class: "ncgr-image",
                          alt: _ctx.campaign.name + _ctx.$t(`item-name.${_ctx.campaign.item.name}.short`)
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_ThumbnailCaption, {
                            "item-name": _ctx.campaign.item.name,
                            scene: _ctx.selectedScene
                          }, null, 8, ["item-name", "scene"])
                        ]),
                        (_ctx.showAchievementBadge)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createTextVNode(" シルク"),
                              _hoisted_10,
                              _createTextVNode("スクリーン"),
                              _hoisted_11,
                              _createTextVNode("でお届け ")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.campaign)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenes, (scene) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: scene,
                            class: "thumb"
                          }, [
                            _createElementVNode("img", {
                              class: "thumb-image",
                              src: _ctx.thumbnailUrl(scene, 'small'),
                              alt: _ctx.campaign.name + _ctx.$t(`item-name.${_ctx.campaign.item.name}.short`),
                              onClick: ($event: any) => (_ctx.changeSelectedScene(scene))
                            }, null, 8, _hoisted_14)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.campaign)
                ? (_openBlock(), _createElementBlock("header", _hoisted_16, [
                    (!_ctx.isSample)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("p", _hoisted_20, " 販売期間：" + _toDisplayString(_ctx.formatDatetime(_ctx.campaign.startAt)) + "〜" + _toDisplayString(_ctx.formatDatetime(_ctx.campaign.endAt)), 1),
                            _createElementVNode("ul", _hoisted_21, [
                              _createElementVNode("li", _hoisted_22, [
                                _createVNode(_component_font_awesome_icon, { icon: "info-circle" }),
                                _createTextVNode(" 他のアイテムと一緒にカートに入れることはできません。 ")
                              ]),
                              _createElementVNode("li", _hoisted_23, [
                                _createVNode(_component_font_awesome_icon, { icon: "info-circle" }),
                                _createTextVNode(" ご注文後のキャンセル、変更はお受けできません。 ")
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createElementVNode("p", _hoisted_27, " 販売期間：" + _toDisplayString(_ctx.formatDatetime(_ctx.campaign.startAt)) + "〜" + _toDisplayString(_ctx.formatDatetime(_ctx.campaign.endAt)), 1),
                            _createElementVNode("ul", _hoisted_28, [
                              _createElementVNode("li", _hoisted_29, [
                                _createVNode(_component_font_awesome_icon, { icon: "info-circle" }),
                                _createTextVNode(" 発注できる数量は3点までです。 ")
                              ]),
                              _createElementVNode("li", _hoisted_30, [
                                _createVNode(_component_font_awesome_icon, { icon: "info-circle" }),
                                _createTextVNode(" 他のアイテムと一緒にカートに入れることはできません。 ")
                              ])
                            ])
                          ])
                        ])),
                    _createElementVNode("h1", _hoisted_31, _toDisplayString(_ctx.campaign.name), 1),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t(`item-name.${_ctx.campaign.item.name}.short`)), 1),
                    (_ctx.selectedVariant)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.formatPrice(_ctx.selectedVariant.priceWithTax)) + "(税込) ", 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", {
                        class: "ncgr-text-field",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.colorSelectorVisbile = true), ["prevent"]))
                      }, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("select", _hoisted_37, [
                            _createElementVNode("option", null, _toDisplayString(_ctx.formatItemColor(_ctx.selectedVariant)), 1)
                          ]),
                          _hoisted_38
                        ])
                      ])
                    ]),
                    _createVNode(_component_Field, {
                      name: "itemSizeId",
                      rules: "required",
                      modelValue: _ctx.itemSizeId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemSizeId) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["ncgr-text-field", { '-color-negative': errors[0] }])
                        }, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("select", _mergeProps(field, {
                              class: "_input",
                              id: "size",
                              name: "size"
                            }), [
                              _hoisted_41,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaign.item.sizes, (size) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: size.id,
                                  value: size.id
                                }, _toDisplayString(_ctx.$t(`item-size.${size.name}`)), 9, _hoisted_42))
                              }), 128))
                            ], 16),
                            _hoisted_43
                          ])
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (!_ctx.isSample)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                          _createTextVNode(" 発送予定日："),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.formatDate(_ctx.campaign.scheduledShippingDate)) + "ごろ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_46,
                    _createElementVNode("div", _hoisted_47, [
                      (_ctx.remainingSeconds)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              disabled: _ctx.buttonDisabled,
                              class: "ncgr-button -color-interactive -size-l -width-full",
                              onClick: ($event: any) => (_ctx.goToCart(validate))
                            }, [
                              _hoisted_50,
                              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.buttonLabel), 1)
                            ], 8, _hoisted_49)), [
                              [_directive_track, void 0, "show_add-cart"]
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createTextVNode(" 販売終了まで "),
                              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.formatTime(_ctx.remainingSeconds)), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              disabled: _ctx.buttonDisabled,
                              class: "ncgr-button -color-interactive -size-l -width-full",
                              onClick: ($event: any) => (_ctx.goToCart(validate))
                            }, [
                              _hoisted_56,
                              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.buttonLabel), 1)
                            ], 8, _hoisted_55)), [
                              [_directive_track, void 0, "show_add-cart"]
                            ])
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_58, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    (_ctx.campaign)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "user-name",
                          href: _ctx.suzuriShopUrl,
                          target: "_blank"
                        }, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("img", {
                              src: _ctx.campaign.user.avatarUrl
                            }, null, 8, _hoisted_63)
                          ]),
                          (_ctx.campaign)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.campaign.user.displayName), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_61))
                      : _createCommentVNode("", true),
                    (_ctx.twitterUrl.length > 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: _ctx.twitterUrl,
                          class: "profile-link"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fab', 'x-twitter'] })
                        ], 8, _hoisted_65))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.campaign && _ctx.campaign.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _hoisted_67,
                        _createElementVNode("p", null, _toDisplayString(_ctx.campaign.description), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isScreenPrinting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_71))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    (_ctx.isSweat)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_74, _hoisted_76))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_77,
                          _hoisted_78
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _hoisted_80,
                    _createElementVNode("ul", _hoisted_81, [
                      (!_ctx.isScreenPrinting)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_82, " 印刷方法は基本的にシルクスクリーン印刷ですが、予約販売期間の販売数が目標数に達しなかった場合は、ホワイトインクジェットプリントで製作されます。どちらの印刷方法で加工されるのかは、販売期間の終了時にメールでお知らせいたします。 "))
                        : _createCommentVNode("", true),
                      _hoisted_83,
                      _hoisted_84,
                      (!_ctx.isScreenPrinting)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_85, " 特色インク(蛍光・金・銀)は、ホワイトインクジェットプリントの場合、仕様上再現が難しく濁った色味になります。 "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_86,
                  _createElementVNode("div", null, [
                    _hoisted_87,
                    (_ctx.campaign)
                      ? (_openBlock(), _createBlock(_component_ItemSpec, {
                          key: 0,
                          "item-name": _ctx.campaign.item.name
                        }, null, 8, ["item-name"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_88, _hoisted_90))
                : _createCommentVNode("", true),
              (!_ctx.isSample)
                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                    _createElementVNode("button", {
                      class: "ncgr-button -appearance-outlined",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shareSheetVisible = true))
                    }, _hoisted_94)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_95, [
        (_ctx.remainingSeconds)
          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
              _createTextVNode(" 販売終了まで "),
              _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.formatTime(_ctx.remainingSeconds)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_98, [
          _createElementVNode("button", {
            disabled: _ctx.buttonDisabled,
            class: "ncgr-button -color-interactive -size-l -width-full",
            onClick: ($event: any) => (_ctx.goToCart(validate))
          }, [
            _hoisted_100,
            _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.buttonLabel), 1)
          ], 8, _hoisted_99)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["ncgr-overlay -transparent", { '-active': _ctx.colorSelectorVisbile }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.colorSelectorVisbile = false))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ncgr-semi-modal", { '-active': _ctx.colorSelectorVisbile }])
      }, [
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", {
                class: "ncgr-button -appearance-transparent -shape-circle",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.colorSelectorVisbile = false))
              }, _hoisted_106)
            ]),
            _hoisted_107
          ])
        ]),
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            (_ctx.campaign)
              ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaign.variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: variant.id,
                        class: "ncgr-col -col-6",
                        onClick: ($event: any) => (_ctx.selectVariant(variant))
                      }, [
                        _createElementVNode("img", {
                          class: _normalizeClass([{ selected: variant.id === _ctx.selectedVariant.id }, "ncgr-square-radio ncgr-square-radio--image square-radio"]),
                          src: _ctx.printedThumbnailUrl(variant, 'small')
                        }, null, 10, _hoisted_113),
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("p", _hoisted_115, _toDisplayString(_ctx.$t(`item-name.${_ctx.campaign.item.name}.short`)) + "本体：" + _toDisplayString(_ctx.formatItemColor(variant)), 1)
                        ])
                      ], 8, _hoisted_112))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ncgr-overlay", { '-active': _ctx.shareSheetVisible }]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.shareSheetVisible = false))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ncgr-semi-modal", { '-active': _ctx.shareSheetVisible }])
      }, [
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", {
                class: "ncgr-button -appearance-transparent -shape-circle",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.shareSheetVisible = false))
              }, _hoisted_120)
            ]),
            _hoisted_121
          ])
        ]),
        _createElementVNode("div", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            (!_ctx.isSample)
              ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                  _createElementVNode("ul", _hoisted_125, [
                    _createElementVNode("li", _hoisted_126, [
                      _withDirectives((_openBlock(), _createElementBlock("a", {
                        href: _ctx.tweetUrl,
                        rel: "noopener",
                        target: "_blank"
                      }, _hoisted_130, 8, _hoisted_127)), [
                        [_directive_track, void 0, "show_share-twitter"]
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_131, [
                      _withDirectives((_openBlock(), _createElementBlock("a", { href: _ctx.lineUrl }, _hoisted_135, 8, _hoisted_132)), [
                        [_directive_track, void 0, "show_share-line"]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}